/**
 * Subimods Support Theater — Advance Beyond the Grid carousel + player
 * Root: [data-sm-support-theater]
 * Docs: SM-SUPPORT-PAGES.md
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sm-support-theater]';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';
  var PREVIEW_DELAY = 420;

  function initRoot(root) {
    if (!root || root.dataset.smTheaterReady === '1') return;
    root.dataset.smTheaterReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sm-theater-card]'));
    if (!cards.length) return;

    var ambient = root.querySelector('[data-sm-theater-ambient]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sm-theater-dot]'));
    var prevBtn = root.querySelector('[data-sm-theater-prev]');
    var nextBtn = root.querySelector('[data-sm-theater-next]');
    var summaryEpisode = root.querySelector('[data-sm-theater-summary-episode]');
    var summaryTitle = root.querySelector('[data-sm-theater-summary-title]');
    var summaryMeta = root.querySelector('[data-sm-theater-summary-meta]');
    var summaryText = root.querySelector('[data-sm-theater-summary-text]');
    var watchBtn = root.querySelector('[data-sm-theater-watch]');
    var watchText = root.querySelector('[data-sm-theater-watch-text]');
    var dialog = root.querySelector('[data-sm-theater-dialog]');
    var player = root.querySelector('[data-sm-theater-player]');
    var closeBtn = root.querySelector('[data-sm-theater-close]');
    var track = root.querySelector('[data-sm-theater-track]');

    var watchLabel = root.getAttribute('data-sm-theater-watch-label') || 'Watch now';
    var soonLabel = root.getAttribute('data-sm-theater-soon-label') || 'Coming soon';
    var previewEnabled = root.getAttribute('data-sm-theater-preview') === '1';
    var reduceMotion = window.matchMedia(REDUCE_MQ).matches;
    var desktopMq = window.matchMedia('(min-width: 900px)');
    var activeIndex = 0;
    var previewTimer = null;
    var touchStartX = null;
    var SIDE_SLOTS = [-2, -1, 1, 2];

    function clampIndex(index) {
      if (index < 0) return cards.length - 1;
      if (index >= cards.length) return 0;
      return index;
    }

    function modIndex(index) {
      var n = cards.length;
      return ((index % n) + n) % n;
    }

    /** Shortest wrapped offset in roughly (-n/2, n/2]. */
    function wrappedOffset(i, active, n) {
      var offset = i - active;
      offset = ((offset % n) + n) % n;
      if (offset > n / 2) offset -= n;
      return offset;
    }

    function clearClones() {
      if (!track) return;
      track.querySelectorAll('[data-sm-theater-clone]').forEach(function (clone) {
        clone.parentNode.removeChild(clone);
      });
    }

    function clearPreviews() {
      cards.forEach(function (card) {
        var mount = card.querySelector('[data-sm-theater-card-preview]');
        if (mount) mount.innerHTML = '';
        card.classList.remove('has-preview');
      });
    }

    function loadMutedPreview(card) {
      if (!previewEnabled || reduceMotion) return;
      if (card.getAttribute('data-coming-soon') === '1') return;

      var ytId = card.getAttribute('data-youtube-id') || '';
      var mount = card.querySelector('[data-sm-theater-card-preview]');
      if (!ytId || !mount) return;

      var src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(ytId) +
        '?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&playsinline=1&loop=1&playlist=' +
        encodeURIComponent(ytId);

      mount.innerHTML =
        '<iframe class="sm-support-theater-card__iframe" src="' +
        src +
        '" title="Episode preview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" tabindex="-1" loading="lazy"></iframe>';
      card.classList.add('has-preview');
    }

    function schedulePreview(card) {
      window.clearTimeout(previewTimer);
      clearPreviews();
      if (!previewEnabled || reduceMotion) return;
      previewTimer = window.setTimeout(function () {
        loadMutedPreview(card);
      }, PREVIEW_DELAY);
    }

    function updateAmbient(card) {
      if (!ambient) return;
      var thumb = card.getAttribute('data-thumb') || '';
      if (thumb) {
        ambient.style.backgroundImage = 'url("' + thumb.replace(/"/g, '\\"') + '")';
        ambient.classList.add('is-visible');
      } else {
        ambient.style.backgroundImage = '';
        ambient.classList.remove('is-visible');
      }
    }

    function updateSummary(card) {
      var episodeLabel = card.getAttribute('data-episode-label') || '';
      var title = card.getAttribute('data-title') || '';
      var meta = card.getAttribute('data-meta') || '';
      var comingSoon = card.getAttribute('data-coming-soon') === '1';
      var source = card.querySelector('[data-sm-theater-summary-source]');

      if (summaryEpisode) summaryEpisode.textContent = episodeLabel;
      if (summaryTitle) summaryTitle.textContent = title;

      if (summaryMeta) {
        if (meta) {
          summaryMeta.textContent = meta;
          summaryMeta.hidden = false;
        } else {
          summaryMeta.textContent = '';
          summaryMeta.hidden = true;
        }
      }

      if (summaryText) {
        summaryText.innerHTML = source ? source.innerHTML : '';
      }

      if (watchBtn) {
        watchBtn.disabled = comingSoon || !(card.getAttribute('data-youtube-id') || '');
        watchBtn.classList.toggle('is-disabled', watchBtn.disabled);
        if (watchText) {
          watchText.textContent = comingSoon ? soonLabel : watchLabel;
        }
      }
    }

    function fillDesktopSides() {
      clearClones();
      if (!track || !desktopMq.matches || cards.length < 2) return;

      var n = cards.length;
      var used = {};

      cards.forEach(function (card, i) {
        var offset = wrappedOffset(i, activeIndex, n);
        used[String(offset)] = true;
        card.setAttribute('data-offset', String(offset));
      });

      SIDE_SLOTS.forEach(function (slot) {
        if (used[String(slot)]) return;

        var sourceIndex = modIndex(activeIndex + slot);
        var source = cards[sourceIndex];
        if (!source) return;

        var clone = source.cloneNode(true);
        clone.classList.remove('is-active', 'has-preview');
        clone.setAttribute('data-sm-theater-clone', '1');
        clone.setAttribute('data-offset', String(slot));
        clone.setAttribute('data-index', String(sourceIndex));
        clone.removeAttribute('id');

        var preview = clone.querySelector('[data-sm-theater-card-preview]');
        if (preview) preview.innerHTML = '';

        var sourceBody = clone.querySelector('[data-sm-theater-summary-source]');
        if (sourceBody) sourceBody.parentNode.removeChild(sourceBody);

        var hit = clone.querySelector('[data-sm-theater-select]');
        if (hit) hit.setAttribute('aria-pressed', 'false');

        track.appendChild(clone);
        used[String(slot)] = true;
      });
    }

    function setActive(index, options) {
      options = options || {};
      activeIndex = clampIndex(index);
      var activeCard = cards[activeIndex];
      if (!activeCard) return;

      var n = cards.length;

      cards.forEach(function (card, i) {
        var offset = desktopMq.matches
          ? wrappedOffset(i, activeIndex, n)
          : i - activeIndex;
        card.setAttribute('data-offset', String(offset));
        card.classList.toggle('is-active', i === activeIndex);
        var hit = card.querySelector('[data-sm-theater-select]');
        if (hit) hit.setAttribute('aria-pressed', i === activeIndex ? 'true' : 'false');
      });

      fillDesktopSides();

      dots.forEach(function (dot, i) {
        var on = i === activeIndex;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });

      updateAmbient(activeCard);
      updateSummary(activeCard);

      if (options.preview !== false) {
        schedulePreview(activeCard);
      }

      if (options.scrollIntoView && track && !desktopMq.matches) {
        activeCard.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }

    function openPlayer(card) {
      if (!dialog || !player) return;
      var ytId = card.getAttribute('data-youtube-id') || '';
      var comingSoon = card.getAttribute('data-coming-soon') === '1';
      if (!ytId || comingSoon) return;

      clearPreviews();
      window.clearTimeout(previewTimer);

      var src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(ytId) +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

      player.innerHTML =
        '<iframe class="sm-support-theater-dialog__iframe" src="' +
        src +
        '" title="Episode player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

      root.classList.add('is-player-open');
      document.documentElement.classList.add('sm-support-theater-lock');

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      if (closeBtn && typeof closeBtn.focus === 'function') {
        closeBtn.focus();
      }
    }

    function closePlayer() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      root.classList.remove('is-player-open');
      document.documentElement.classList.remove('sm-support-theater-lock');
      if (player) player.innerHTML = '';
      schedulePreview(cards[activeIndex]);
    }

    root.addEventListener('click', function (event) {
      var selectBtn = event.target.closest('[data-sm-theater-select]');
      if (selectBtn && root.contains(selectBtn)) {
        var card = selectBtn.closest('[data-sm-theater-card]');
        if (!card) return;
        var index = Number(card.getAttribute('data-index') || 0);
        if (card.classList.contains('is-active') && card.getAttribute('data-coming-soon') !== '1') {
          openPlayer(card);
          return;
        }
        setActive(index, { scrollIntoView: true });
        return;
      }

      var dot = event.target.closest('[data-sm-theater-dot]');
      if (dot && root.contains(dot)) {
        setActive(Number(dot.getAttribute('data-index') || 0), { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-theater-prev]')) {
        setActive(activeIndex - 1, { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-theater-next]')) {
        setActive(activeIndex + 1, { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-theater-watch]')) {
        openPlayer(cards[activeIndex]);
        return;
      }

      if (event.target.closest('[data-sm-theater-close]')) {
        closePlayer();
      }
    });

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closePlayer();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closePlayer();
      });
      dialog.addEventListener('close', function () {
        root.classList.remove('is-player-open');
        document.documentElement.classList.remove('sm-support-theater-lock');
        if (player) player.innerHTML = '';
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!root.contains(document.activeElement) && !root.classList.contains('is-player-open')) {
        return;
      }
      if (root.classList.contains('is-player-open')) {
        if (event.key === 'Escape') closePlayer();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(activeIndex - 1, { scrollIntoView: true });
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(activeIndex + 1, { scrollIntoView: true });
      }
    });

    if (track) {
      track.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        function (event) {
          if (touchStartX == null) return;
          var delta = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(delta) < 40) return;
          if (delta > 0) setActive(activeIndex - 1, { scrollIntoView: true });
          else setActive(activeIndex + 1, { scrollIntoView: true });
        },
        { passive: true }
      );
    }

    if (prevBtn) prevBtn.disabled = cards.length < 2;
    if (nextBtn) nextBtn.disabled = cards.length < 2;

    function onDesktopChange() {
      setActive(activeIndex, {
        preview: false,
        scrollIntoView: !desktopMq.matches
      });
    }

    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', onDesktopChange);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(onDesktopChange);
    }

    setActive(0, {
      preview: true,
      scrollIntoView: !desktopMq.matches
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target && event.target.querySelector ? event.target.querySelector(ROOT_SEL) : null;
    if (root) {
      delete root.dataset.smTheaterReady;
      initRoot(root);
    } else {
      initAll();
    }
  });
})();
